import React, { useEffect } from 'react';
import { Link, useRouteError } from 'react-router';

const CHUNK_RELOAD_KEY = 'moms:chunk-reload-attempted';

const isChunkLoadError = (err: unknown): boolean => {
  if (!err) return false;
  const msg =
    typeof err === 'string'
      ? err
      : (err as { message?: string })?.message ?? String(err);
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|not a valid JavaScript MIME type/i.test(
    msg,
  );
};

export function NotFound() {
  const error = useRouteError();

  useEffect(() => {
    if (!isChunkLoadError(error)) return;
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }, [error]);

  return (
    <div className="w-full min-h-screen bg-[var(--color-bg)] flex flex-col items-center justify-center px-[20px]">
      <div className="text-center">
        <h1
          className="text-[48px] mb-[16px]"
          style={{ fontFamily: 'Georgia, serif', color: '#6E2726' }}
        >
          404
        </h1>
        <p className="text-[16px] mb-[24px]" style={{ color: '#7A6459' }}>
          Страница не найдена
        </p>
        <Link
          to="/"
          className="inline-block bg-[#6E2726] text-white rounded-[20px] px-[24px] py-[12px] text-[14px] font-semibold"
        >
          На главную
        </Link>
      </div>
    </div>
  );
}
